module.exports = __webpack_public_path__ + "img/setting.bf61449d.svg";